import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import { COUNT_INVITATIONS_PER_PAGE } from 'constants/constants';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client/react';
import {
  DeleteUserAccountDocument,
  InvitationsByLoanConsultantDocument,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';

const useDeleteUserAccount = (): [(userId: string) => Promise<void>, boolean] => {
  const [deleteUserAccountMutation, { loading }] = useMutation(DeleteUserAccountDocument);
  const { formatMessage: t } = useIntl();
  const { page } = useParams<{ page?: string }>();

  const deleteAccount = useCallback(
    async (userId: string) => {
      try {
        await deleteUserAccountMutation({
          variables: { userId },
          refetchQueries: [
            {
              query: InvitationsByLoanConsultantDocument,
              variables: {
                limit: COUNT_INVITATIONS_PER_PAGE,
                offset: COUNT_INVITATIONS_PER_PAGE * (Number(page) - 1),
                filter: '',
              },
            },
          ],
          awaitRefetchQueries: true,
        });
        toast.success(t({ id: 'invitations.user_successfully_deleted' }));
      } catch (error) {
        const e = withRaw(toGraphqlError(error), error || '');
        toast.error(e.message);
      }
    },
    [deleteUserAccountMutation, page, t],
  );
  return [deleteAccount, loading];
};

export default useDeleteUserAccount;
